import { useEffect, type RefObject } from 'react';
import { useCropStore } from '../store/cropStore';

export const useCropInitializer = (imgRef: RefObject<HTMLImageElement>): void => {
  const { setOriginalDimensions, isImageLoaded } = useCropStore();

  useEffect(() => {
    // Set original dimensions when image is loaded
    if (imgRef.current && isImageLoaded) {
      const { naturalWidth, naturalHeight } = imgRef.current;
      setOriginalDimensions(naturalWidth, naturalHeight);
    }
  }, [isImageLoaded, setOriginalDimensions]);

  // react-easy-crop handles crop initialization internally
  // It starts with the image centered and fully visible (zoom = 1)
};
